/** Age helpers for the 18+ signup gate (Terms of Use / Community Guidelines). */

export const MINIMUM_AGE = 18;

/** Whole years between the date of birth (ISO yyyy-mm-dd) and today. */
export const calculateAge = (dateOfBirth: string): number => {
  const birth = new Date(dateOfBirth);
  if (Number.isNaN(birth.getTime())) return NaN;

  const now = new Date();
  let age = now.getFullYear() - birth.getFullYear();
  const monthDelta = now.getMonth() - birth.getMonth();
  if (monthDelta < 0 || (monthDelta === 0 && now.getDate() < birth.getDate())) {
    age -= 1;
  }
  return age;
};

export const isAdult = (dateOfBirth: string): boolean => {
  const age = calculateAge(dateOfBirth);
  return !Number.isNaN(age) && age >= MINIMUM_AGE;
};
